var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44563 3.99978C7.47408 3.98119 6.52696 4.30494 5.77007 4.91435C5.01319 5.52375 4.49479 6.37998 4.30563 7.33312H1.77896V8.66645H4.33229C4.52304 9.61383 5.03818 10.465 5.78899 11.0735C6.5398 11.6819 7.47929 12.0095 8.44563 11.9998H11.779V3.99978H8.44563Z",
    fill: "#AFAFB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9729 15.3337H20.5396C20.3456 14.383 19.8259 13.5298 19.0701 12.9212C18.3143 12.3127 17.3699 11.987 16.3996 12.0004H13.1129V13.3337H9.77961C9.6028 13.3337 9.43323 13.404 9.30821 13.529C9.18318 13.654 9.11295 13.8236 9.11295 14.0004C9.11295 14.1772 9.18318 14.3468 9.30821 14.4718C9.43323 14.5968 9.6028 14.6671 9.77961 14.6671H13.1129V17.3337H9.77961C9.6028 17.3337 9.43323 17.404 9.30821 17.529C9.18318 17.654 9.11295 17.8236 9.11295 18.0004C9.11295 18.1772 9.18318 18.3468 9.30821 18.4718C9.43323 18.5968 9.6028 18.6671 9.77961 18.6671H13.1129V20.0004H16.4063C17.3783 20.0179 18.3257 19.6939 19.0834 19.0848C19.8411 18.4757 20.3612 17.6201 20.5529 16.6671H22.9796L22.9729 15.3337Z",
    fill: "#AFAFB0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisconnect);
export default __webpack_public_path__ + "static/media/icon-disconnect.510b036f722e780e9c02d023a43c1e0f.svg";
export { ForwardRef as ReactComponent };